module.exports = __webpack_public_path__ + "static/guide_2-cc7021730f692682f7f3d543b131dcd3.jpg";